<template>
    <el-button :type="type" :size="size" @click="handleClick" :loading="loading" :disabled="disabled">
        <slot></slot>
    </el-button>
</template>

<script>
import { MessageBox } from 'element-ui';

export default {
    name: 'HintButton',
    props: {

        // 所需积分数量
        functionName: {
            type: String,
            default: '',
        },

        // 所需积分数量
        pointsNumber: {
            type: Number,
            default: 0
        },
        // 按钮类型，同element-ui按钮
        type: {
            type: String,
            default: 'primary'
        },
        // 按钮大小
        size: {
            type: String,
            default: 'medium'
        },
        // 是否加载中
        loading: {
            type: Boolean,
            default: false
        },
        // 是否禁用
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleClick() {
            MessageBox.confirm(
                `该功能所需${this.pointsNumber}积分，您确定要继续${this.functionName}吗？`,
                '温馨提示！',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).then(() => {
                this.$emit('confirm');
            }).catch(() => {
                this.$emit('cancel');
            });
        }
    }
};
</script>